import { Injectable } from '@angular/core';
import { AppointmentScheduleRequestModel } from '../business-entities/appointmentSchedule-request-model';
import { GenericResponse } from './../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { SaveAppointmentPlanning } from './../business-entities/save-appointment-planning.model';


@Injectable({ providedIn: 'root' })
export class AppointmentPlanningDataService {
    constructor(
        private dataProvider: DataService
    ) {}


    getAppointmentScheduleDetails(requestModel:AppointmentScheduleRequestModel): any  {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetAppointmentSchedule,requestModel).toPromise();    
    }
    getMechanicScheduleDetailsPlanningMenu(requestModel:AppointmentScheduleRequestModel): any  {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetMEchanicSchedulePlanningMenu,requestModel).toPromise();    
    }

    saveAppointmentPlanning(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.SaveAppointmentPlanning, model).toPromise();
    }
    saveSplitBooking(model: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.SaveSplitBooking, model).toPromise();
    }
    DeleteAppointmentPlanning(model: any): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.DeleteAppointmentBooking, model).toPromise();
    }
    UpdateAppointmentPlanningTime(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateAppointmentPlanning, model).toPromise();
    }
    getMechanicMonthwiseDetails(requestModel:any): any  {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetMechanicMonthwiseDetails,requestModel).toPromise();    
    }
    getWeekData(requestModel:any): any  {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetWeekData,requestModel).toPromise();    
    }
    getScheduleSummary(requestModel:any): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetScheduleSummaryPlanningMenu, requestModel).toPromise();
    }
    getMechanicInOutOverTime(requestModel:any): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetMechanicInOutOverTime, requestModel).toPromise();
    }
    getMechanicInOutSummary(requestModel:any): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetMechanicInOutSummary, requestModel).toPromise();
    }
    GetWeekViewPlanning(requestModel:any): any {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.GetWeekViewPlanning, requestModel).toPromise();
    }
    GetWOMechanicList(dealerId:string, dmsSyncRequired: boolean): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetWOMechanicForPlanning, dealerId, dmsSyncRequired).toPromise();
    }
    GetMechanicJobListForWO(workOrderNo:string): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetMechanicJobListForWO, workOrderNo).toPromise();
    }
    saveMechanicBlockedSlot(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.SaveMechanicBlockedSlot, model).toPromise();
    }
    DeleteBlockedMechanicSlot(slotId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteBlockedMechanicSlot, slotId).toPromise();
    }
    UpdateMechanicBlockedSlot(model: SaveAppointmentPlanning): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.UpdateMechanicBlockedSlot, model).toPromise();
    }
    
}